import { render, staticRenderFns } from "./sixPopover.vue?vue&type=template&id=03977f3f&scoped=true&"
import script from "./sixPopover.vue?vue&type=script&lang=js&"
export * from "./sixPopover.vue?vue&type=script&lang=js&"
import style0 from "./sixPopover.vue?vue&type=style&index=0&id=03977f3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03977f3f",
  null
  
)

export default component.exports